export default "__VITE_ASSET__9k9pm3Fv__"